import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import { getLabelCategories } from "../policy/policySlide";
import styles from "../policy/policy.module.scss";
import { Attendance } from "../attendance/Attendance";

export function CategoryList() {
  const dispatch = useDispatch();
  const history = useHistory();
  const categories = useSelector((state) => state.policy?.categories ?? []);
  const status = useSelector((state) => state.policy.status);
  const user = useSelector((state) => state.authentication?.user);
  const isAdminOrQA = user && (user.is_admin || user.is_admin_or_qa);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      setLoading(true);
      try {
        await dispatch(getLabelCategories());
      } catch (error) {
        console.error('Error loading categories:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadCategories();
  }, [dispatch]);

  const handleEditCategory = (id) => {
    history.push(`/category/edit/${id}`);
  };

  return (
    <div className={styles.policyPageContainer}>
      <div className={styles.policyPageHeader}>
        <div className={styles.headerContent}>
          <h1 className={styles.pageTitle}>Category Management</h1>
          <p className={styles.pageSubtitle}>
            Manage and organize your content moderation categories
          </p>
        </div>
        <div className={styles.headerActions}>
          <div className={styles.attendanceSection}>
            <Attendance />
          </div>
          {isAdminOrQA && (
            <Link to="/category/create" className={styles.createButton}>
              <i className=""></i>
              Create New Category
            </Link>
          )}
        </div>
      </div>

      <div className={styles.policyPageContent}>
        {loading ? (
          <div className={styles.loadingState}>
            <div className={styles.loadingSpinner}></div>
            <p>Loading categories...</p>
          </div>
        ) : categories && categories.length > 0 ? (
          <div className={styles.policyTableWrapper}>
            <table className={styles.categoryTable}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  {/* <th>Parent ID</th> */}
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(categories) && categories.map((category) => (
                  <tr key={category.id} onClick={() => handleEditCategory(category.id)}>
                    <td>{category.id}</td>
                    <td>{category.name}</td>
                    {/* <td>{category.parent_id || 'N/A'}</td> */}
                    <td className={styles.actionsCell}>
                      <button onClick={(e) => { e.stopPropagation(); handleEditCategory(category.id); }} className={styles.editButton}>
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyStateIcon}>
              <i className="fas fa-file-alt"></i>
            </div>
            <h3>No Categories Found</h3>
            <p>Get started by creating your first category</p>
            {isAdminOrQA && (
              <Link to="/category/create" className={styles.emptyStateButton}>
                Create Your First Category
              </Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoryList; 